import React from 'react';
import ClaimDetails from './ClaimPage/ClaimDetails';
import withClaimQuery from './HOC/withClaimQuery';

const ClaimPreview = ({ claim, loading }) =>
  claim ? <ClaimDetails claim={claim} loading={loading} previewOnly /> : null;

export default withClaimQuery(ClaimPreview);



// WEBPACK FOOTER //
// ./src/component/ClaimPreview.js